import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _ZoomOutCustom(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", d: "M20.5 20.5 17 17" }),
            React.createElement("circle", { cx: 11, cy: 11, r: 8.5, stroke: "currentColor" }),
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", d: "M7.25 11.25h7.5" })));
}
const ZoomOutCustom = forwardRef(_ZoomOutCustom);
export { ZoomOutCustom };
